import { createContext, useContext, useMemo } from 'react';
import { useAddQueryMutation, LocalMutationsProvider } from 'crm-object-search-query-utilities/localMutations';

// Create context for new object IDs
import { jsx as _jsx } from "react/jsx-runtime";
export const NewObjectIdsContext = /*#__PURE__*/createContext(undefined);

// Hook to use the context
export const useNewObjectIdsContext = () => {
  const context = useContext(NewObjectIdsContext);
  if (!context) {
    throw new Error('useNewObjectIds must be used within a ReconciliationLocalMutationsProvider');
  }
  return context;
};
export const ReconciliationLocalMutationsProvider = ({
  children,
  newObjectIds
}) => {
  const contextValue = useMemo(() => {
    return {
      newObjectIds: newObjectIds !== null && newObjectIds !== void 0 ? newObjectIds : []
    };
  }, [newObjectIds]);
  let alreadyHasContext = true;
  try {
    //will throw an error if it doesnt exist
    useAddQueryMutation();
  } catch (e) {
    alreadyHasContext = false;
  }
  if (alreadyHasContext) {
    return /*#__PURE__*/_jsx(NewObjectIdsContext.Provider, {
      value: contextValue,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(NewObjectIdsContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(LocalMutationsProvider, {
      children: children
    })
  });
};